import { StyledProgressIndicator, ProgressIndicatorWrapper, ProgressIndicatorProgress } from './ProgressIndicator.styles';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProgressIndicator = ({
  totalSteps,
  currentStepNumber,
  shouldHalveProgressBar = false
}) => {
  let currentProgress = Math.round(currentStepNumber / (totalSteps + 1) * 100);
  if (shouldHalveProgressBar) {
    currentProgress = currentProgress / 2;
  }
  return /*#__PURE__*/_jsx(StyledProgressIndicator, {
    children: /*#__PURE__*/_jsx(ProgressIndicatorWrapper, {
      children: /*#__PURE__*/_jsx(ProgressIndicatorProgress, {
        "aria-label": `Step ${currentStepNumber} of ${totalSteps}`,
        use: "warning",
        value: currentProgress
      })
    })
  });
};